import { render, staticRenderFns } from "./projectManger.vue?vue&type=template&id=39a23d56&scoped=true&"
import script from "./projectManger.vue?vue&type=script&lang=js&"
export * from "./projectManger.vue?vue&type=script&lang=js&"
import style0 from "./projectManger.vue?vue&type=style&index=0&id=39a23d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a23d56",
  null
  
)

export default component.exports